export enum Screens {
  AboutScreen = "About Screen",
  GameScreen = "Game Screen",
  StartScreen = "Start Screen",
  VariantSelectScreen = "Variant Select Screen",
  NimbusStartScreen = "Nimbus Start Screen",
  NimbusGameScreen = "Nimbus Game Screen",
  NimbusAboutScreen = "Nimbus About Screen",
}
